import React from 'react';
import { CreditCard, Wallet } from 'lucide-react';
import Card from '../components/ui/Card';
import CardContent from '../components/ui/CardContent';
import Layout from '../components/Layout';

const PaymentPage = () => {
  const paymentMethods = [
    
    {
      title: "Банковские карты",
      description: "Visa, MasterCard, МИР",
      details: "Безопасная оплата через процессинговый центр",
      icon: <CreditCard className="w-6 h-6" />
    },
    {
      title: "Электронные кошельки",
      description: "ЮMoney",
      details: "Моментальное зачисление средств",
      icon: <Wallet className="w-6 h-6" />
    }
  ];

  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Способы оплаты</h1>
        <div className="grid gap-6">
          {paymentMethods.map((method, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="p-3 bg-blue-100 rounded-lg">
                    {method.icon}
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold mb-2">{method.title}</h2>
                    <p className="text-gray-600 mb-2">{method.description}</p>
                    <pre className="text-sm text-gray-500 whitespace-pre-wrap">{method.details}</pre>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default PaymentPage;